import React, { memo } from "react";

export const EmployeeInfo = memo((props) => {
  const { user } = props;

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingMtemployee">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseMtemployee" aria-expanded="false" aria-controls="panelsStayOpen-collapseMtemployee">
                個人情報
            </button>
        </h2>
        <div id="panelsStayOpen-collapseMtemployee" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingMtemployee">
          <div className="accordion-body bg-white">
            <table className="table table-striped mt-3">
              <tbody>
                <tr>
                  <th>氏名</th>
                  <td>
                    <a href={`/agent/employees/${user.id}/edit`}>
                      {user.name}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th>氏名（かな）</th>
                  <td>{user.kana}</td>
                </tr>
                <tr>
                  <th>被保険者証記号</th>
                  <td>{user.insurance_sign}</td>
                </tr>
                <tr>
                  <th>被保険者証番号</th>
                  <td>{user.insuranceno}</td>
                </tr>
                <tr>
                  <th>性別</th>
                  <td>{user.sex}</td>
                </tr>
                <tr>
                  <th>生年月日（年度内年齢）</th>
                  <td>{user.birthdate}</td>
                </tr>
                <tr>
                  <th>住所（検査キット等送付先）</th>
                  <td>{user.address}</td>
                </tr>
                <tr>
                  <th>電話番号</th>
                  <td>{user.tel}</td>
                </tr>
                <tr>
                  <th>メールアドレス</th>
                  <td>{user.email}</td>
                </tr>
                <tr>
                  <th>受診資格</th>
                  <td>{user.eligible}</td>
                </tr>
                <tr>
                  <th>申込可能コース</th>
                  <td>{user.emp_order_category}</td>
                </tr>
                <tr>
                  <th>資格情報</th>
                  <td>{user.emp_rank_code}</td>
                </tr>
                <tr>
                  <th>在籍状況</th>
                  <td>{user.retired}</td>
                </tr>
                <tr>
                  <th>任継状況</th>
                  <td>{user.ninkei}</td>
                </tr>
                <tr>
                  <th>人事DT更新日</th>
                  <td>{user.resource_updated_date}</td>
                </tr>
                <tr>
                  <th>入社日</th>
                  <td>{user.joined_date}</td>
                </tr>
                <tr>
                  <th>健保資格取得日</th>
                  <td>{user.certified_date}</td>
                </tr>
                <tr>
                  <th>昇格日</th>
                  <td>{user.promoted_date}</td>
                </tr>
                <tr>
                  <th>降格日</th>
                  <td>{user.relegated_date}</td>
                </tr>
                <tr>
                  <th>退職日</th>
                  <td>{user.retired_date}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
});